import React, { useEffect, useState } from 'react';
import './FaqsPopup.css'; // Make sure the CSS file is in the same directory
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FAQS_LIST } from './Keywords';
import { useUserAuth } from "../context/UserAuthContext";

const FaqsPopup = ({ isVisible, onClose, onSelectNote}) => {
  const { userDataLocal } = useUserAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [isVisibleFAQs, setIsVisibleFAQs] = React.useState(false);
  const [faqList, setFaqList] = useState(FAQS_LIST['en-US']);
  const [formData, setFormData] = useState({
    name: userDataLocal?.Name,
    email: userDataLocal?.Email,
    phone: '',
    subject: '',
    message: ''
  });

  const [showEmailProgress, setShowEmailProgress] = useState(false);
  const [emailStatus, setEmailStatus] = useState({
    progress: 0,
    status: 'idle',
    sent: 0,
    total: 0,
    estimatedTimeRemaining: null
  });

  useEffect(() => {
    setIsVisibleFAQs(true);
    const lancode = userDataLocal?.Language.code;
    if (FAQS_LIST[lancode].length < 2) { 
      setFaqList(FAQS_LIST['en-US']);
    } else {
      setFaqList(FAQS_LIST[lancode]);
    }
    
    return () => {
      setIsVisibleFAQs(false);
    };
  }, []);

  function handleClose () {
    setIsVisibleFAQs(false);
    onClose();
  }

  // if (!isVisible) {
  //   setIsVisibleFAQs(false);
  //   // return null;
  // }
  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // 修改轮询函数，更新状态而非直接操作DOM
  function pollStatus(taskId) {
    setShowEmailProgress(true); // 显示进度UI
    
    const statusInterval = setInterval(async () => {
      try {
        const response = await fetch(`/api/send-emails/status/${taskId}`);
        if (!response.ok) {
          clearInterval(statusInterval);
          console.error("Status polling failed");
          return;
        }
        
        const status = await response.json();
        
        // 更新状态对象，React会重新渲染UI
        setEmailStatus(status);
        
        // 如果任务完成或失败，停止轮询
        if (status.status === 'completed' || status.status === 'failed') {
          clearInterval(statusInterval);
          // 任务完成5秒后隐藏进度条
          setTimeout(() => setShowEmailProgress(false), 5000);
        }
      } catch (error) {
        console.error("Error polling status:", error);
      }
    }, 5000); // 每5秒查询一次
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(formData && userDataLocal?.Email === 'support@metaspringai.com' && formData?.name.includes('Bulk Email')) {
      const response = await fetch('/api/send-emails', {
      // const response = await fetch('/api/send-bulk-emails', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      const taskId = data.taskId;
      setFormData({
        name: userDataLocal?.Name,
        email: userDataLocal?.Email,
        phone: '',
        subject: '',
        message: ''
      });
      // 开始轮询状态并显示进度UI
      if (taskId) {
        setEmailStatus({ 
          progress: 0, 
          status: 'starting', 
          sent: 0, 
          total: 0 
        });
        setShowEmailProgress(true);
        pollStatus(taskId);
      }
    } else {
      fetch('https://springai.pythonanywhere.com/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then((data) => {
        alert('Email sent successfully!');
        setFormData({
          name: userDataLocal?.Name,
          email: userDataLocal?.Email,
          phone: '',
          subject: '',
          message: ''
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Email sending failed!');
      });
    }
  };

    return (
      <div className={`popup-background-FAQs ${isVisibleFAQs ? 'active' : ''}`}>
          <div className='popup-FAQs'>
            <div className='header-FAQs'>
              <h1 className='h1-FAQs'>FAQs</h1>

              <span className="close-FAQs" onClick={handleClose}>&times;</span>
            </div>
            <div className="content-FAQs">
              {faqList.map((faq, index) => {
                const key = Object.keys(faq)[0];
                const value = faq[key];

                return (
                  <div key={index}>
                    <div className="date-header-FAQs">{key}</div>
                    <div className="note-container-FAQs">
                      {Array.isArray(value) ? value.flatMap((item, idx, arr) => {
                        const [boldPart, rest] = item.split(/:(.+)/);
                        return [
                          <div key={idx}><strong>{boldPart}:</strong>{rest}</div>,
                          idx < arr.length - 1 ? <br /> : null
                        ];
                      }) : <div>{value}</div>}
                    </div>
                  </div>
                );
              })}
              <div className="container-FAQs-Contact">
                {/* <div className="section-title-FAQs-Contact text-center-FAQs-Contact">
                  <span className="section-title__tagline-FAQs-Contact">Contact with us</span>
                  <h2 className="section-title__title-FAQs-Contact">Write us a message</h2>
                </div> */}
                <div className="date-header-FAQs">Contact with us</div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="contact-page__form-FAQs-Contact">
                      <form onSubmit={handleSubmit} className="comment-one__form-FAQs-Contact contact-form-validated-FAQs-Contact">
                        <div className="row">
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="text"
                                name="name"
                                placeholder="Your name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="text"
                                name="phone"
                                placeholder="Phone number"
                                value={formData.phone}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <input
                                type="text"
                                name="subject"
                                placeholder="Subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="comment-form__input-box-FAQs-Contact">
                              <textarea
                                name="message"
                                placeholder="Write Message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                              ></textarea>
                            </div>
                            <button type="submit" className="thm-btn-FAQs-Contact faqs-contact__btn-FAQs-Contact">
                              <span>Send a message</span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* 添加批量邮件发送管理员区域，仅对管理员显示 */}
              {userDataLocal?.Email === 'support@metaspringai.com' && (
                <div className="admin-section">
                  <div className="date-header-FAQs">Admin: Bulk Email Tool</div>
                  <div className="note-container-FAQs">
                    <p>Enter "Bulk Email" in the name field to activate bulk email sending to all users.</p>
                  </div>
                </div>
              )}
              
              {/* 邮件发送进度显示区域 */}
              {showEmailProgress && (
                <div className="email-progress-container" style={{margin: '20px 0', padding: '15px', border: '1px solid #ddd', borderRadius: '5px'}}>
                  <h3>Bulk Email Status</h3>
                  <div style={{marginBottom: '10px'}}>
                    <div id="status-text">Status: {emailStatus.status}, Sent: {emailStatus.sent}/{emailStatus.total}</div>
                    {emailStatus.estimatedTimeRemaining && (
                      <div id="time-remaining">
                        Estimated time remaining: {Math.ceil(emailStatus.estimatedTimeRemaining / 60000)} mins
                      </div>
                    )}
                  </div>
                  <div style={{width: '100%', height: '20px', background: '#eee', borderRadius: '10px'}}>
                    <div 
                      id="email-progress"
                      style={{
                        width: `${emailStatus.progress || 0}%`, 
                        height: '100%', 
                        background: '#4CAF50', 
                        borderRadius: '10px',
                        transition: 'width 0.5s'
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        {/* </div> */}
          
      </div>
      );
    };

export default FaqsPopup;